// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"5895":"42c4c2aa","6093":"dc969d8f"}[chunkId] + ".css";
};